// context/ThemeContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { theme } from "antd";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const darkThemeLink = document.getElementById("dark-theme");
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add("dark");
      document.body.classList.add("e-dark");
      if (darkThemeLink) darkThemeLink.removeAttribute("disabled");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      if (darkThemeLink) darkThemeLink.setAttribute("disabled", "true");
      document.body.classList.remove("e-dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  const toggleTheme = () => setDarkMode(prev => !prev);

  const antTheme = {
    algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: darkMode
      ? {
        colorBgBase: "#17153B",
        colorBgContainer: "#17153B",
        colorText: "#ffffff",
        colorPrimary: "#A855F7",
        colorTextPlaceholder: "#b3b3b3",
        colorIcon: "#ffffff",
      }
      : {
        colorBgBase: "#ffffff",
        colorBgContainer: "#ffffff",
        colorText: "#000000",
        colorPrimary: "#722ED1",
        colorTextPlaceholder: "#a0a0a0",
        colorIcon: "#000000",
      }
  };

  // 👈 react-select custom theme
  const reactSelectTheme = {
    control: (provided) => ({
      ...provided,
      backgroundColor: darkMode ? "#17153B" : "#fff",
      color: darkMode ? "#fff" : "#000",
      borderColor: darkMode ? "#4E36A3" : "#d9d9d9",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: darkMode ? "#17153B" : "#fff",
      color: darkMode ? "#fff" : "#000",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: darkMode ? "#fff" : "#000",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: darkMode ? "#b3b3b3" : "#a0a0a0",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? darkMode
          ? "#4E36A3"
          : "#f5f5f5"
        : darkMode
          ? "#17153B"
          : "#fff",
      color: darkMode ? "#fff" : "#000",
      fontSize: "12px",   // 👈 option text size
      minHeight: "32px",  // 👈 option ki height
      display: "flex",
      alignItems: "center", // vertical center text
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: darkMode ? "#fff" : "#000",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: darkMode ? "#555" : "#ccc",
    }),
    input: (provided) => ({
      ...provided,
      color: darkMode ? "#fff" : "#000", // 👈 typed text ka color
    }),
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleTheme, antTheme, reactSelectTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
